import { api, setSelectedClusterId } from './api-client';
import type { MyClustersResponse } from '@residenone/shared';

export async function getMyClusters(): Promise<MyClustersResponse> {
  const { data } = await api.get<MyClustersResponse>('/admin/my-clusters', { headers: { 'X-Cluster-ID': '' } });
  return data;
}

export async function switchCluster(cluster_id: string): Promise<void> {
  await api.post('/admin/switch-cluster/clerk', { cluster_id });
  setSelectedClusterId(cluster_id);
}
